import React from "react";

const HowItWorks = () => {
  const steps = [
    {
      title: "Waste Collection",
      description:
        "Organic waste is collected from farms, industries, or municipalities.",
      image: "/images/imgBio/bioCard1.png",
    },
    {
      title: "Anaerobic Digestion",
      description:
        "Waste is processed in oxygen-free digesters, where microorganisms break it down and produce biogas.",
      image: "/images/imgBio/bioCard2.png",
    },
    {
      title: "Energy Generation",
      description:
        "Biogas is used to generate electricity, heat, or upgraded into biomethane for grid injection or vehicle fuel.",
      image: "/images/imgBio/bioCard3.png",
    },
    {
      title: "By-Products Reuse",
      description:
        "Digestate is reused as nutrient-rich fertilizer, closing the loop of the circular economy.",
      image: "/images/imgBio/bioCard4.png",
    },
  ];

  return (
    <section className="px-[20px]">
      <div className="max-w-[1612px] mx-auto">
        <h2 className="text-[30px] md:text-[60px] font-bold text-[#1C233A] text-center mb-12">
          How It Works
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {steps.map((step, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-[2rem] min-h-[592px] flex flex-col justify-end cursor-pointer transition-all duration-500"
            >
              {/* 1. THE BACKGROUND IMAGE (Visible on hover) */}
              <div
                className="absolute inset-0 z-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-110"
                style={{ backgroundImage: `url(${step.image})` }}
              />

              {/* 2. THE DARK GRADIENT (Ensures white text is readable on hover) */}
              <div className="absolute inset-0 z-10 bg-gradient-to-t from-black via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

              {/* 3. THE GREEN OVERLAY (Solid color, fades out on hover) */}
              <div className="absolute inset-0 z-20 bg-[#bada8b] opacity-100 group-hover:opacity-0 transition-opacity duration-500" />

              {/* 4. CONTENT */}
              <div className="relative z-30 p-8 transition-colors duration-500">
                <h3 className="text-[24px] lg:text-[30px] font-bold mb-3 leading-tight transition-colors duration-500 text-[#1e293b] group-hover:text-white">
                  {step.title}
                </h3>
                <p className="text-[20px] lg:text-[24px] leading-relaxed transition-colors duration-500 text-[#1e293b] text-justify group-hover:text-gray-200">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
